import ConfigService from "@/service/ConfigService";

const STANDARD_ASSETS = {
    dashboardIcon: "logo/dashboard_icon.png",
    companyBrandIcon: "logo/company_brand_icon.png",
    favicon: "logo/favicon.png",
    loginLogo: "logo/login_logo.svg",
    themeStylesheet: "css/theme.css",
};

const ASSET_ALIASES = {
    sidebarLogo: "dashboardIcon",
    fullLogo: "companyBrandIcon",
};

const MIME_TYPES = {
    svg: "image/svg+xml",
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    webp: "image/webp",
    gif: "image/gif",
    ico: "image/x-icon",
};

class AssetService {
    joinPath(basePath, relativePath) {
        const normalizedBase = basePath.endsWith("/") ? basePath : `${basePath}/`;
        return normalizedBase + relativePath.replace(/^\//, "");
    }

    async getAssetsBasePath() {
        return ConfigService.getAssetsBasePath();
    }

    async getAsset(key) {
        const basePath = await this.getAssetsBasePath();
        const overrides = await ConfigService.getAssetOverrides();
        const assetKey = ASSET_ALIASES[key] || key;
        const relativePath = overrides[assetKey] || overrides[key] || STANDARD_ASSETS[assetKey];
        if (!relativePath) {
            console.warn(`Unknown asset key: ${key}`);
            return "";
        }
        return this.joinPath(basePath, relativePath);
    }

    async getAssetUrl(relativePath) {
        const basePath = await this.getAssetsBasePath();
        return this.joinPath(basePath, relativePath);
    }

    async applyFavicon() {
        const url = await this.getAsset("favicon");
        if (!url) {
            return;
        }
        let link = document.querySelector("link[rel*='icon']");
        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
        }
        link.href = url;
        link.type = this.getMimeType(url);
    }

    async applyThemeStylesheet() {
        const url = await this.getAsset("themeStylesheet");
        if (!url) {
            return;
        }
        let link = document.querySelector("link[data-client-theme]");
        if (!link) {
            link = document.createElement("link");
            link.rel = "stylesheet";
            link.setAttribute("data-client-theme", "true");
            document.head.appendChild(link);
        }
        link.href = url;
        link.type = "text/css";
    }

    getMimeType(url) {
        const extension = url.split("?")[0].split("#")[0].split(".").pop().toLowerCase();
        return MIME_TYPES[extension] || "image/png";
    }
}

export default new AssetService();
